import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  getCallrollList: null,
  getCallrollListSuccess: ['data'],
  setCallrollId: ['id'],
  setCallrollList: ['list'],
  startCallroll: null,
  startCallrollSuccess: ['data'],
  getStuList: null,
  getStuListSuccess: ['data'],
  stopCounting: null,
  cancelRollcall: null,
  cancelRollcallSuccess: ['data'],
  closeRollcall: ['id'],
  closeRollcallSuccess: ['data'],
  getRollcallListByLessonId: null,
  getRollcallListByLessonIdSuccess: ['data'],
  resetCallroll: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  list: [],
  id: null,
  lotteryRecordId: null,
  stuList: [],
  counting: false,
  callrollList: [],
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Type.GET_CALLROLL_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    list: action.data,
    id: action.data.length > 0 ? action.data[0].callRollId : null,
  }),
  [Type.SET_CALLROLL_ID]: (state = INITIAL_STATE, action) => ({
    ...state,
    id: action.id,
  }),
  [Type.SET_CALLROLL_LIST]: (state = INITIAL_STATE, action) => ({
    ...state,
    list: action.list,
  }),
  [Type.START_CALLROLL_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    id: action.data.lotteryId,
    lotteryRecordId: action.data.lotteryRecordId,
    counting: true,
  }),
  [Type.GET_STU_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    stuList: action.data,
  }),
  [Type.STOP_COUNTING]: (state = INITIAL_STATE, action) => ({
    ...state,
    counting: false,
  }),
  [Type.CANCEL_ROLLCALL]: (state = INITIAL_STATE, action) => ({
    ...state,
    counting: false
  }),
  [Type.CANCEL_ROLLCALL_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    lotteryRecordId: null,
  }),
  [Type.CLOSE_ROLLCALL_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
  }),
  [Type.GET_ROLLCALL_LIST_BY_LESSON_ID_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    callrollList: action.data,
  }),
  [Type.RESET_CALLROLL]: (state = INITIAL_STATE, action) => ({
    ...state,
    list: [],
    id: null,
    lotteryRecordId: null,
    counting: false,
  }),
});
